import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Adminlayout from "../Adminlayout";
import { useDispatch, useSelector } from "react-redux";
import CapBox from "../../bloc/CapBox";
import LabelDecs from "../../bloc/LabelDecs";
import authService from "../../services/auth.service";
import AlertNotification from "./AlertNotification";

const MyApplicationsForm2 = () => {
  const dispatch = useDispatch();
  const student = useSelector((state) => state.auth.studentData);
  const navigate = useNavigate();

  const [paymentStatus, setpaymentStatus] = useState("");

  const PayChalan = (data) => {
    const requiredFields = [
      "name",
      "email",
      "phone_number",
      "gender",
      "category",
      "academic_level",
      "course_name",
      "course_year",
      "date_of_birth",
      "aadhaar_no",
      "nationality",
      "up_residence",
      "subcategory",
      "certificate_no",
      "father_name",
      "father_occupation",
      "mother_name",
      "mother_occupation",
      "marital_status",
      "whatsapp",
      "address",
      "village",
      "post",
      "tehsil",
      "district",
      "pincode",
      "profile_photo",
    ];

    const missingFieldsList = requiredFields
      .filter((field) => !student[field])
      .map((field) => {
        return field
          .split("_")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ");
      });

    // 3. If there are any missing fields, show them in a list
    if (missingFieldsList.length > 0) {
      // Construct an HTML bulleted list
      const listHtml = `
      <p style="text-align: left; margin-bottom: 10px;">The following fields are required:</p>
      <ul style="text-align: left; max-height: 200px; overflow-y: auto; padding-left: 20px;">
        ${missingFieldsList.map((field, index) => `<li key={${index}}>${field}</li>`).join("")}
      </ul>
    `;

      Swal.fire({
        title: "Complete your Profile",
        html: listHtml, // Use 'html' instead of 'text'
        icon: "warning",
        showConfirmButton: true,
      });
      return;
    }

    navigate(`/student/payment?program=${data}`);
  };

  useEffect(() => {
    authService.getUser(dispatch);
  }, []);

  useEffect(() => {
    if (
      !student ||
      !Array.isArray(student.transactions) ||
      student.transactions.length === 0
    ) {
      setpaymentStatus("Pending");
    } else {
      const filtered = student.transactions.filter(
        (t) =>
          t.amount == 50 &&
          new Date(t.created_at).getFullYear() === 2026 &&
          String(t.status).toLowerCase() === "success",
      );
      setpaymentStatus(
        filtered.length > 0 ? filtered[filtered.length - 1] : "Pending",
      );
    }
  }, [student]);

  const allCourses = [
    {
      name: "Bachelor of Science (Maths)",
      code: "BSCMATH",
      forms: [
        {
          link: "bscmath/part-1",
          label: "BS.C (Maths) 1st Year",
          product: "BSCMATH-1",
        },
        {
          link: "bscmath/part-2",
          label: "BS.C (Maths) 2nd Year",
          product: "BSCMATH-2",
        },
        {
          link: "bscmath/part-3",
          label: "BS.C (Maths) 3rd Year",
          product: "BSCMATH-3",
        },
      ],
    },
    {
      name: "Bachelor of Science (Zoology)",
      code: "BSCBIO",
      forms: [
        {
          link: "bscbio/part-1",
          label: "BS.C (BIO) 1st Year",
          product: "BSCBIO-1",
        },
        {
          link: "bscbio/part-2",
          label: "BS.C (BIO) 2nd Year",
          product: "BSCBIO-2",
        },
        {
          link: "bscbio/part-3",
          label: "BS.C (BIO) 3rd Year",
          product: "BSCBIO-3",
        },
      ],
    },
    {
      name: "Bachelor of Commerce",
      code: "BCOM",
      forms: [
        { link: "bcom/part-1", label: "BCOM 1st Year", product: "BCOM-1" },
        { link: "bcom/part-2", label: "BCOM 2nd Year", product: "BCOM-2" },
        { link: "bcom/part-3", label: "BCOM 3rd Year", product: "BCOM-3" },
      ],
    },
    {
      name: "Masters of Commerce",
      code: "MCOM",
      forms: [
        // { link: "mcom/part-1", label: "MCOM 1st Year", product: "MCOM-1" },
        { link: "mcom/part-2", label: "MCOM 2nd Year", product: "MCOM-2" },
        // { link: "mcom/part-3", label: "MCOM 3rd Year", product: "MCOM-3" },
      ],
    },
  ];

  const hasOpenApplication =
    student?.open_applications &&
    Object.keys(student.open_applications).length > 0 &&
    student.open_applications["form-link"];

  const getSpecificForm = () => {
    if (!hasOpenApplication) return null;

    const openApp = student.open_applications;
    const formLink = openApp["form-link"];
    const courseName = openApp.course_name;

    const course = allCourses.find((c) => c.code === courseName);
    if (!course) return null;

    const form = course.forms.find((f) => f.link === formLink);
    if (!form) return null;

    return {
      course: course,
      form: form,
      challan_status: openApp.challan_status || false,
    };
  };

  const applyNow = (data) => {
    if (!student.is_academic_filled) {
      Swal.fire({
        title: "Complete your academic details",
        icon: "warning",
        showConfirmButton: true,
      });
      return;
    }
    console.log(data);
    navigate(`/student/admission-form/${data}`);
  };

  const isButtonDisabled = (challanStatus) => {
    return challanStatus === true || paymentStatus?.status === "success";
  };

  const renderSpecificFormCard = (course, form, challanStatus) => {
    return (
      <div key={form.link} className="main-dashboard-card">
        <div className="main-dashboard-card-header main-dashboard-helpdesk-header">
          <div>
            <CapBox />
            <div>
              <h2 className="main-dashboard-card-title">{course.name}</h2>
              <p className="main-dashboard-card-subtitle">Admission Forms</p>
            </div>
          </div>
        </div>
        <div className="my-admission-form-box">
          <div className="my-admission-form">
            <LabelDecs title={"FORM NUMBER"} text={"N/A"} />
            <LabelDecs title={"PROGRAM LEVEL"} text={"BACHELOR"} />
            <LabelDecs
              title={"NEXT STEP"}
              text={challanStatus ? "APPLY NOW" : "RETRY"}
            />
            <LabelDecs title={"PAYMENT/SUBMISSION DATE"} text={"12-05-2026"} />
            <LabelDecs
              title={"ADMISSION STATUS"}
              text={student.status == 1 ? "APPROVED" : "PENDING"}
              color={student.status == 1 ? "lightgreen" : "red"}
            />
            <LabelDecs
              title={"CHALAN STATUS"}
              color={"lightgreen"}
              text={challanStatus ? "PAID" : "UNPAID"}
            />
          </div>
          <div className="available-form">
            <LabelDecs title={"Available Form"} text={""} />

            <div>
              <label>{`Admission form for ${form.label}`}</label>
              {challanStatus == true ? (
                <div>
                  {student.is_admission_submitted == false &&
                  student.is_admission_fee_payed === false ? (
                    <button
                      onClick={() => applyNow(form.link)}
                      className="main-dashboard-button"
                    >
                      Apply Now
                    </button>
                  ) : (
                    <div>
                      {student.is_admission_fee_payed === false ? (
                        <button
                          onClick={() => navigate(`/student/admission/payment`)}
                          className="main-dashboard-button"
                        >
                          Pay - ₹{student.fee_to_pay}
                        </button>
                      ) : (
                        <Link
                          className="main-dashboard-button"
                          target="_blank"
                          to={`/admission-form/print/${student.admission_code}`}
                        >
                          Print
                        </Link>
                      )}
                    </div>
                  )}
                </div>
              ) : challanStatus == false ? (
                <button
                  disabled={isButtonDisabled(challanStatus)}
                  onClick={() => PayChalan(form.product)}
                  className="main-dashboard-button"
                >
                  Retry
                </button>
              ) : (
                <button
                  disabled={isButtonDisabled(challanStatus)}
                  onClick={() => PayChalan(form.product)}
                  className="main-dashboard-button"
                >
                  Pay Chalan
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const date = new Date().toISOString().split("T")[0].split("-")[0];

  const isChalanPayed = student?.transactions?.find((t) => {
    const date = new Date().toISOString().split("T")[0].split("-")[0];

    const dateMatch = t.addedon.split(" ")[0].split("-")[0];
    if (dateMatch === date && t.status === "success" && t.amount === "50.00") {
      return t;
    }
  });

  const isChalanApproved = student?.open_applications?.find((o) => {
    const regFee = o.fee_type.split("(")[0];
    const amount = o.fee_type.split("(")[1].split(".")[0];
    if (
      regFee === "reg fee" &&
      amount == "50" &&
      o.status === "1" &&
      o?.challan_id === isChalanPayed?.txnid
    ) {
      return o;
    }
  });

  const isApplicationFilled =
    student?.admissions?.enrollment_year === date ? student?.admissions : false;

  const isAdmissionFeePayed = student?.admissions?.is_paid ? true : false;

  const isApprovedAdmissionFee = student?.admissions?.admision_approved
    ? true
    : false;

  const renderAllCourses = () => {
    if ("MCOM" === student.course_name && "1" === student.course_year) {
      const Data = allCourses.find((cor) => cor.code === "MCOM");

      return (
        <>
          {Data.forms.map((form, index) => (
            <div key={index} className="main-dashboard-card">
              <div className="main-dashboard-card-header main-dashboard-helpdesk-header">
                <div>
                  <CapBox />
                  <div>
                    <h2 className="main-dashboard-card-title">
                      Masters Of Commerce
                    </h2>
                    <p className="main-dashboard-card-subtitle">
                      Admission Forms
                    </p>
                  </div>
                </div>
              </div>
              <div className="my-admission-form-box">
                <div className="my-admission-form">
                  <LabelDecs title={"FORM NUMBER"} text={"N/A"} />
                  <LabelDecs title={"PROGRAM LEVEL"} text={"MASTERS"} />
                  <LabelDecs
                    title={"NEXT STEP"}
                    text={
                      !isChalanPayed ? (
                        "Pay Challan"
                      ) : (
                        <>
                          {isChalanPayed && !isChalanApproved ? (
                            "Wait For Approval"
                          ) : (
                            <>
                              {isChalanPayed &&
                              isChalanApproved &&
                              !isApplicationFilled ? (
                                "Apply Now"
                              ) : (
                                <>
                                  {isChalanPayed &&
                                  isChalanApproved &&
                                  isApplicationFilled &&
                                  !isAdmissionFeePayed ? (
                                    "Pay Admission Fee"
                                  ) : (
                                    <>
                                      {isChalanPayed &&
                                      isChalanApproved &&
                                      isApplicationFilled &&
                                      isAdmissionFeePayed &&
                                      !isApprovedAdmissionFee
                                        ? "Print Admission Form"
                                        : "Admission Completed"}
                                    </>
                                  )}
                                </>
                              )}
                            </>
                          )}
                        </>
                      )
                    }
                  />

                  <LabelDecs
                    title={"ADMISSION STATUS"}
                    text={isApprovedAdmissionFee ? "Completed" : "Pending"}
                  />
                </div>
                <div className="available-form">
                  {!isChalanPayed ? (
                    <div>
                      <label className="blink-text">
                        {`${form.label} Admission Form - Pay the challan to unlock the admission form.`}
                      </label>

                      <button
                        onClick={() => PayChalan(form.product)}
                        className="main-dashboard-button"
                      >
                        Pay Challan
                      </button>
                    </div>
                  ) : (
                    <>
                      {isChalanPayed && !isChalanApproved ? (
                        <div>
                          <label className="blink-text">
                            {`${form.label} Admission Form - Your challan has been paid and is awaiting college approval.`}
                          </label>

                          <Link
                            className="main-dashboard-button"
                            target="_blank"
                            to={`/chalan-receipt/print/${isChalanPayed?.txnid}`}
                          >
                            Print Challan
                          </Link>
                        </div>
                      ) : (
                        <>
                          {isChalanPayed &&
                          isChalanApproved &&
                          !isApplicationFilled ? (
                            <div>
                              <label className="blink-text">
                                {`${form.label} Admission Form - Your challan has been approved. Click “Apply Now” to fill out the admission form.`}
                              </label>

                              <button
                                onClick={() => applyNow(form.link)}
                                className="main-dashboard-button"
                              >
                                Apply Now
                              </button>
                            </div>
                          ) : (
                            <>
                              {isChalanPayed &&
                              isChalanApproved &&
                              isApplicationFilled &&
                              !isAdmissionFeePayed ? (
                                <div>
                                  <label className="blink-text">
                                    {`${form.label} Admission Form - Your application has been submitted. Please pay the admission fee to complete the process.`}
                                  </label>

                                  <button
                                    onClick={() =>
                                      navigate(
                                        `/student/admission/payment?program=${form.product}`,
                                      )
                                    }
                                    className="main-dashboard-button"
                                  >
                                    Pay - ₹{student?.fee_to_pay}
                                  </button>
                                </div>
                              ) : (
                                <>
                                  {isChalanPayed &&
                                  isChalanApproved &&
                                  isApplicationFilled &&
                                  isAdmissionFeePayed &&
                                  !isApprovedAdmissionFee ? (
                                    <div>
                                      <label className="blink-text">
                                        {`${form.label} Admission Form - Your admission fee has been paid and is pending college approval.`}
                                      </label>

                                      <div>
                                        <button
                                          onClick={() =>
                                            navigate(
                                              `/admission-form/print/${student?.admissions?.admission_code}`,
                                            )
                                          }
                                          className="main-dashboard-button"
                                        >
                                          Print Admission Form
                                        </button>
                                      </div>
                                    </div>
                                  ) : (
                                    <div>
                                      <label className="blink-text">
                                        {`${form.label} Admission Form - Admission completed successfully. You can now print your admission form.`}
                                      </label>

                                      <button
                                        onClick={() =>
                                          navigate(
                                            `/admission-form/print/${student?.admissions?.admission_code}`,
                                          )
                                        }
                                        className="main-dashboard-button"
                                      >
                                        Admission Completed - Print Form
                                      </button>
                                    </div>
                                  )}
                                </>
                              )}
                            </>
                          )}
                        </>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          ))}

          <div className="admission-flow">
            <div className="admission-flow-title">Admission Process</div>

            <div className="admission-flow-steps">
              <div
                className={`admission-step ${
                  isChalanPayed ? "completed" : "active"
                }`}
              >
                <div className="admission-step-circle">
                  {isChalanPayed ? "✓" : "1"}
                </div>

                <div className="admission-step-content">
                  <div className="admission-step-title">Pay Challan</div>
                  <div className="admission-step-description">
                    Pay your challan
                  </div>
                </div>
              </div>
              <div
                className={`admission-step-line ${
                  isChalanPayed ? "completed" : ""
                }`}
              />

              <div
                className={`admission-step ${
                  isChalanApproved ? "completed" : isChalanPayed ? "active" : ""
                }`}
              >
                <div className="admission-step-circle">
                  {isChalanApproved ? "✓" : "2"}
                </div>

                <div className="admission-step-content">
                  <div className="admission-step-title">Challan Approval</div>
                  <div className="admission-step-description">
                    College approval
                  </div>
                </div>
              </div>
              <div
                className={`admission-step-line ${
                  isChalanApproved ? "completed" : ""
                }`}
              />

              <div
                className={`admission-step ${
                  isApplicationFilled
                    ? "completed"
                    : isChalanApproved
                      ? "active"
                      : ""
                }`}
              >
                <div className="admission-step-circle">
                  {isApplicationFilled ? "✓" : "3"}
                </div>

                <div className="admission-step-content">
                  <div className="admission-step-title">Admission Form</div>
                  <div className="admission-step-description">
                    Fill application
                  </div>
                </div>
              </div>
              <div
                className={`admission-step-line ${
                  isApplicationFilled ? "completed" : ""
                }`}
              />

              <div
                className={`admission-step ${
                  isAdmissionFeePayed
                    ? "completed"
                    : isApplicationFilled
                      ? "active"
                      : ""
                }`}
              >
                <div className="admission-step-circle">
                  {isAdmissionFeePayed ? "✓" : "4"}
                </div>

                <div className="admission-step-content">
                  <div className="admission-step-title">Admission Fee</div>
                  <div className="admission-step-description">
                    Pay admission fee
                  </div>
                </div>
              </div>
              <div
                className={`admission-step-line ${
                  isAdmissionFeePayed ? "completed" : ""
                }`}
              />

              <div
                className={`admission-step ${
                  isApprovedAdmissionFee
                    ? "completed"
                    : isAdmissionFeePayed
                      ? "active"
                      : ""
                }`}
              >
                <div className="admission-step-circle">
                  {isApprovedAdmissionFee ? "✓" : "5"}
                </div>

                <div className="admission-step-content">
                  <div className="admission-step-title">Admission Approval</div>
                  <div className="admission-step-description">
                    College approval
                  </div>
                </div>
              </div>
              <div
                className={`admission-step-line ${
                  isApprovedAdmissionFee ? "completed" : ""
                }`}
              />

              <div
                className={`admission-step ${
                  isApprovedAdmissionFee ? "completed" : ""
                }`}
              >
                <div className="admission-step-circle">
                  {isApprovedAdmissionFee ? "✓" : "6"}
                </div>

                <div className="admission-step-content">
                  <div className="admission-step-title">Completed</div>
                  <div className="admission-step-description">
                    Print admission form
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      );
    }

    return (
      <h4>No admission is available at the moment. Please check back later.</h4>
    );
  };

  const renderContent = () => {
    if (!student) {
      return <p>Loading...</p>;
    }

    if (hasOpenApplication) {
      const specificForm = getSpecificForm();
      if (specificForm) {
        return renderSpecificFormCard(
          specificForm.course,
          specificForm.form,
          specificForm.challan_status,
        );
      }
    }

    return renderAllCourses();
  };

  return (
    <Adminlayout>
      <AlertNotification />
      {renderContent()}
    </Adminlayout>
  );
};

export default MyApplicationsForm2;
